<template>
  <v-dialog v-model="dialog" max-width="450">
    <template v-slot:activator="{ on, attrs }">
      <v-menu transition="slide-x-transition" offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" rounded small elevation="0" color="primary">
            <v-icon small>mdi-translate-variant</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-bind="attrs"
            v-on="on"
            v-for="(item, i) in langItem"
            @click="selectedLang = item.value"
            :key="i"
            id="select_lang"
          >
            <v-list-item-content class="pa-3 custom-font">
              <v-list-item-title> {{ item.title }} </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
    <v-card class="custom-font py-3">
      <v-card-title class="primary--text font-weight-bold">
        <span class="mx-auto">{{ cardText ? cardText.title : "" }}</span>
      </v-card-title>
      <v-card-actions class="d-flex justify-space-around">
        <v-btn
          color="error"
          class="font-weight-bold"
          small
          text
          @click="changeLang"
          >{{ cardText ? cardText.yes : "" }}</v-btn
        >
        <v-btn
          color="secondary"
          class="font-weight-bold"
          small
          text
          @click="dialog = false"
          >{{ cardText ? cardText.no : "" }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      lang: this.$i18n.locale,
      selectedLang: null
    };
  },
  computed: {
    cardText() {
      const titles = {
        en: {
          title: "Are you sure want to change",
          yes: "Yes",
          rtl: false,
          no: "No"
        },
        ar: {
          title: "هل أنت متأكد أنك تريد التغيير ",
          yes: "نعم",
          rtl: true,
          no: "لا"
        }
      };
      return titles[this.selectedLang];
    },
    langItem() {
      let language;
      if (this.$i18n.locale === "en") {
        language = [{ title: "عربي", value: "ar" }];
      } else if (this.$i18n.locale === "ar") {
        language = [{ title: "English", value: "en" }];
      }
      return language;
    }
  },
  methods: {
    changeLang() {
      this.$i18n.locale = this.selectedLang;
      this.$vuetify.rtl = this.selectedLang === "en" ? false : true;
      localStorage.setItem("RENTAL_APP_LANG", this.selectedLang);
      this.dialog = false;
    }
  }
};
</script>

<style scoped></style>
